import type { Dictionary } from "./en";

export const ptBr: Partial<Dictionary> = {
  "lang.select": "Idioma",
  "lang.change": "Mudar idioma",

  "nav.hot": "Hot",
  "nav.categories": "Categorias",
  "nav.marketplace": "Marketplace",
  "nav.fund": "Financiar",
  "nav.promote": "Divulgar",
  "nav.earn": "Ganhar",
  "nav.referrals": "Indicações",
  "nav.soon": "Em breve",
  "nav.login": "Entrar",
  "nav.dashboard": "Painel",
  "nav.getHot": "Fique Hot",
  "nav.menu": "Menu",
  "nav.walletBalance": "Saldo de Heat",
  "nav.home": "Início do BeHot.Now",
  "nav.profile": "Painel",
  "nav.messages": "Mensagens",
  "nav.logout": "Sair",
  "nav.balance": "Saldo",

  "footer.tagline": "Um só lugar para descobrir, contratar, vender e promover. Entre no ranking. Fique HOT. Seja visto.",
  "footer.howItWorks": "Como funciona",
  "footer.operatedBy": "Operado por",
  "footer.disclosure":
    "Posições pagas são claramente identificadas como pagas. Preços exibidos em USD.",
  "footer.platform": "Plataforma",
  "footer.comingSoon": "Em breve",
  "footer.legal": "Jurídico",
  "footer.hotNow": "Hot agora",
  "footer.hotHistory": "Histórico HOT",
  "footer.getHot": "Fique Hot",
  "footer.referrals": "Indicações",
  "footer.withdrawal": "Direito de arrependimento",
  "footer.terms": "Termos de serviço",
  "footer.privacy": "Política de privacidade",
  "footer.cookie": "Política de cookies",
  "footer.rights": "Todos os direitos reservados.",
  "footer.compareLeaderboards": "Comparar com outros rankings",

  "home.h1.q": "O que é",
  "home.h1.a1": "É onde",
  "home.h1.anything": "qualquer coisa",
  "home.h1.a2": "pode competir por atenção!",
  "home.sub1": "Você é influenciador, figura pública ou celebridade?",
  "home.sub2":
    "Ou tem uma música, um show, um perfil, uma marca, uma startup, um app, um produto, um negócio, um evento ou até só uma ideia?",
  "home.getItOnCharts": "Coloque nos rankings",
  "home.now": "agora",
  "home.moreBoosts": "Mais boosts.",
  "home.higherRanking": "Posição mais alta.",
  "home.morePeople": "Mais gente vê você.",
  "home.more": "Mais",
  "home.browseChart": "Ver o ranking de {label}",
  "home.listIt": "PUBLIQUE",
  "home.boostIt": "IMPULSIONE",
  "home.climb": "SUBA",
  "home.getSeen": "SEJA VISTO",
  "home.howItWorks": "Como funciona",
  "home.generalBoard": "RANKING GERAL",
  "home.podium.title": "Top 3 de cada board",
  "home.podium.sub": "O pódio atual de cada board de categoria.",
  "home.generalBoardSub":
    "Os melhores anúncios de todas as categorias, ordenados pelo Heat ativo total.",
  "home.allBoards": "Todos os rankings",
  "home.loadingBoard": "Carregando o ranking geral…",

  "lowHeat.title": "Seu Heat está acabando",
  "lowHeat.body":
    "Seu Heat está acabando — convide amigos e ganhe mais Heat ou recarregue sua carteira agora.",
  "lowHeat.invite": "Convidar amigos",
  "lowHeat.topUp": "Recarregar carteira",
  "lowHeat.later": "Depois",

  "cookie.title": "Usamos cookies",
  "cookie.accept": "Aceitar tudo",
  "cookie.reject": "Recusar não essenciais",
  "cookie.settings": "Configurações de cookies",
  "cookie.save": "Salvar escolhas",

  "common.close": "Fechar",
  "common.loading": "Carregando…",
  "hiw.h1": "Como o BeHot.Now funciona",
  "hiw.toc": "Nesta página",
  "hiw.toc.title": "Índice",
  "hiw.toc.steps": "Os cinco passos",
  "hiw.toc.rules": "Regras de ranking",
  "hiw.toc.entry": "Como funciona o preço de entrada",
  "hiw.toc.glossary": "Glossário",
  "hiw.toc.pricing": "Preços",
  "hiw.toc.faq": "Perguntas frequentes",
  "hiw.toc.roadmap": "O que vem a seguir",
  "hiw.toc.services": "Todos os serviços",
  "hiw.toc.contact": "Fale conosco",
  "hiw.steps.title": "Os cinco passos",
  "hiw.ready.title": "Pronto para competir?",
  "hiw.ready.body": "Publique seu projeto ou veja o que está bombando agora.",
  "hiw.ready.list": "Publicar agora",
  "hiw.ready.browse": "Ver as paradas",
  "hiw.rules.title": "Regras de ranking",
  "hiw.entry.title": "Como funciona o preço de entrada no board",
  "hiw.entry.intro": "Entrar em um board é simples, mas o preço é dinâmico. Você sempre paga o menor Heat ativo do board mais o incremento do board. Este exemplo mostra exatamente como funciona.",
  "hiw.entry.lowest": "Menor Heat ativo atual no board",
  "hiw.entry.plus": "+ incremento",
  "hiw.entry.increment": "Incremento do board",
  "hiw.entry.min": "Seu custo mínimo de entrada",
  "hiw.entry.note": "Se o board estiver vazio ou recém-reiniciado, o custo de entrada é a oferta de abertura — normalmente 3 Heat — então os primeiros entram barato antes da disputa esquentar.",
  "hiw.heat": "{n} Heat",
  "hiw.glossary.title": "Glossário",
  "hiw.pricing.title": "Preços",
  "hiw.pricing.oneHeat": "Preço de 1 Heat",
  "hiw.pricing.oneHeatNote": "Pagamento único · sem assinatura",
  "hiw.pricing.listing": "Preço da publicação",
  "hiw.pricing.listingNote": "Para publicar seu projeto em um board",
  "hiw.pricing.entry": "Entrada no board",
  "hiw.pricing.entryValue": "Menor Heat + incremento",
  "hiw.pricing.entryNote": "Exemplo: 12 Heat + 1 = 13 Heat para entrar",
  "hiw.pricing.opening": "Oferta de abertura",
  "hiw.pricing.openingNote": "Custo de entrada em um board novo ou vazio",
  "hiw.faq.title": "Perguntas frequentes",
  "hiw.roadmap.title": "O que vem a seguir",
  "hiw.soon": "Em breve",
  "hiw.promote.body": "Compre ações promocionais reais de criadores: posts, stories, menções e collabs, com preços fixos, escrow e comprovação de entrega.",
  "hiw.promote.more": "Saiba mais sobre o Promote",
  "hiw.earn.body": "Criadores publicam sua tabela de preços, recebem contratações diretas, entregam com comprovação e sacam os ganhos em USD.",
  "hiw.earn.more": "Saiba mais sobre o Earn",
  "hiw.services.title": "Todos os serviços, explicados",
  "hiw.services.intro": "O BeHot.Now é muito mais que o board. Aqui está tudo o que a plataforma faz hoje e tudo o que está a caminho.",
  "hiw.services.open": "Abrir {name}",
  "hiw.contact.title": "Fale com a gente",
  "hiw.contact.intro": "Escolha o serviço do seu contato — incluindo Suporte e Vendas — e encaminhamos para o time certo.",
  "hiw.cta.title": "Pronto para a posição 01?",
  "hiw.cta.button": "Entrar em um board",
  "stats.liveUsers": "{n} usuários ao vivo",
  "stats.totalVisits": "{n} visitas totais",
};
